// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '';
const INTRANET_DASHBOARD = '/intranet';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: '/',
  intranetLogin: path(ROOTS_AUTH, '/intranet/login'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  page404: '/404',
};

export const PATH_DASHBOARD = {
  root: INTRANET_DASHBOARD,

  // intranet paths
  intranetDashboard: path(INTRANET_DASHBOARD, '/app'),
  intranetBookings: {
    root: path(INTRANET_DASHBOARD, '/richieste'),
    new: path(INTRANET_DASHBOARD, '/richieste/nuova'),
    list: path(INTRANET_DASHBOARD, '/richieste/lista'),
    view: (id) => path(INTRANET_DASHBOARD, `/richieste/${id}`),
    edit: (id) => path(INTRANET_DASHBOARD, `/richieste/${id}/modificare`),
    bookingCompleted: path(INTRANET_DASHBOARD, '/fatturazione'),
  },
  clientUser: {
    root: path(INTRANET_DASHBOARD, '/utente/cliente'),
    new: path(INTRANET_DASHBOARD, '/utente/cliente/nuova'),
    list: path(INTRANET_DASHBOARD, '/utente/cliente/lista'),
    edit: (id) => path(INTRANET_DASHBOARD, `/utente/cliente/${id}/modificare`),
    view: (id) => path(INTRANET_DASHBOARD, `/utente/cliente/${id}`),
  },
  intranetUser: {
    root: path(INTRANET_DASHBOARD, '/utente'),
    new: path(INTRANET_DASHBOARD, '/utente/nuova'),
    list: path(INTRANET_DASHBOARD, '/utente/lista'),
    edit: (id) => path(INTRANET_DASHBOARD, `/utente/${id}/modificare`),
    view: (id) => path(INTRANET_DASHBOARD, `/utente/${id}`),
  },
  intranetMediator: {
    root: path(INTRANET_DASHBOARD, '/utente/mediatrice'),
    new: path(INTRANET_DASHBOARD, '/utente/mediatrice/nuova'),
    list: path(INTRANET_DASHBOARD, '/utente/mediatrice/lista'),
    edit: (id) => path(INTRANET_DASHBOARD, `/utente/mediatrice/${id}/modificare`),
    view: (id) => path(INTRANET_DASHBOARD, `/utente/mediatrice/${id}`),
  },
  intranetProfile: path(INTRANET_DASHBOARD, '/profilo'),
  invoice: path(INTRANET_DASHBOARD, '/invoice'),
  invoiceNew: path(INTRANET_DASHBOARD, '/invoice/new'),
  invoiceDetail: (id) => path(INTRANET_DASHBOARD, `/invoice/${id}`),
  languageList: path(INTRANET_DASHBOARD, '/lingue'),
  translationOrders: path(INTRANET_DASHBOARD, '/traduzioni'),
};
